<template>
  <LayoutLogin>
    <template v-slot:content>
      <LayoutLoginCard>
        <Logo class="logo" type="big" />

        <LoaderSpinner v-if="isLoading" />

        <template v-else>
          <p>
            {{ $t('auth.access.accept_terms_of_service') }}
          </p>

          <ul class="list">
            <li>
              <a
                class="link"
                target="__blank"
                :href="$t('auth.access.terms_of_service_url')"
              >
                {{ $t('auth.access.our_terms_of_service') }}
              </a>
            </li>

            <li>
              <a
                class="link"
                target="__blank"
                :href="$t('auth.access.privacy_policy_url')"
              >
                {{ $t('auth.access.our_privacy_policy') }}
              </a>
            </li>

            <li v-if="hasCustomTOCs">
              <a class="link" target="__blank" :href="organizationTermsURL">
                {{ $t('auth.access.your_organization_terms_of_service') }}
              </a>
            </li>
          </ul>

          <Button
            block
            class="mt-6"
            color="primary"
            data-testid="acceptTOCs-button-accept"
            :text="$t('auth.access.accept_terms_of_service_button')"
            @click="handleAccept"
          />

          <Button
            block
            class="mt-6"
            color="grey"
            data-testid="acceptTOCs-button-logOut"
            :text="$t('auth.access.log_out')"
            @click="handleLogout"
          />
        </template>
      </LayoutLoginCard>
    </template>
  </LayoutLogin>
</template>

<script>
import LoaderSpinner from '@/components/utils/LoaderSpinner.vue'
import LayoutLogin from '@/components/Core/Layout/LayoutLogin.vue'
import LayoutLoginCard from '@/containers/Access/components/LayoutLoginCard.vue'
import Logo from '@/components/Core/Logo/Logo.vue'
import Button from '@/components/UI/Button'

import mixin from '@/mixins/mixin.vue'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'AcceptTOCs',

  mixins: [mixin],

  components: {
    LayoutLogin,
    LayoutLoginCard,
    Logo,
    LoaderSpinner,
    Button,
  },

  data() {
    return {
      isLoading: false,
    }
  },

  computed: {
    ...mapState({
      account: state => state?.access?.account,
    }),

    organizationTermsURL() {
      return this.account?.organization?.privacyPolicyURL
    },

    hasCustomTOCs() {
      return Boolean(this.account?.organization?.privacyPolicyURL)
    },
  },

  methods: {
    ...mapActions({
      logout: 'logout',
      acceptTermsOfService: 'acceptTermsOfService',
    }),

    async handleAccept() {
      const organizationId = this.account?.organization._id
      const accountId = this.account?._id

      this.isLoading = true

      try {
        await this.acceptTermsOfService({ organizationId, accountId })
        this.navigateTo(this.$route.query?.redirect ?? '/home')
      } catch (err) {
        this.showError(err.message)
      } finally {
        this.isLoading = false
      }
    },

    handleLogout() {
      this.navigateTo('/logout')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/transitions.scss';

.logo {
  text-align: center;
  margin: 0 auto 24px;
}

.loader-container {
  height: auto;
  padding-top: 70px;
  padding-bottom: 20px;
}

.list {
  margin-top: 16px;
  padding-inline-start: 16px;
}

.link {
  text-decoration: underline;
  cursor: pointer;
}
</style>
